/**
 * Maps route prefixes to SupportHero article slugs.
 * Matched longest-prefix-first so /complaints/new beats /complaints.
 * Add entries here to make the toolbar help icon open a specific article.
 */
const helpArticles = [
  { path: '/complaints', article: '177642-klagomaal' },
  { path: '/host/complaints', article: '177642-klagomaal' },
];

const BASENAME = '/dashboard';

export const getHelpArticle = (pathname) => {
  const path = pathname.startsWith(BASENAME) ? pathname.slice(BASENAME.length) : pathname;
  const match = helpArticles
    .filter((entry) => path === entry.path || path.startsWith(`${entry.path}/`))
    .sort((a, b) => b.path.length - a.path.length)[0];
  return match ? match.article : null;
};
